/* eslint-disable no-console */
class Logging {
  log = (...args: any[]) => {
    console.log(...args);
  };

  debug = (...args: any[]) => {
    console.debug(...args);
  };

  warn = (...args: any[]) => {
    console.warn(...args);
  };

  error = (...args: any[]) => {
    console.error(...args);
  };

  count = (...args: any[]) => {
    console.count(...args);
  };

  trace = (...args: any[]) => {
    console.trace(...args);
  };
}

export default new Logging();
